import * as Styled from "./style";
import { IMAGE } from "~/components/blocks/layout/global-navi/const/image";
import { URL } from "~/components/blocks/layout/global-navi/const/url";
import { MenuItem } from "~/components/blocks/layout/global-navi/mobile/left/dmm-service/header/menu-item";
import { useViewableRatingBlock } from "~/hooks/use-viewable-rating-block";
import { sendTrackingClickCommon } from "~/lib/tracking/events";
import { useAuth } from "~/provider/auth";

export const Header = () => {
  const { isLoggedIn } = useAuth();
  const { isAdultLinkAllowed } = useViewableRatingBlock();
  const isShowFANZAlink = isLoggedIn && isAdultLinkAllowed;

  return (
    <Styled.DivHeader>
      <Styled.DivMenuItemWrapper>
        <MenuItem href={URL.top} src={IMAGE.top} title="総合トップへ" alt="top" />
        <MenuItem href={URL.help} src={IMAGE.help} title="ヘルプ" alt="help" />
      </Styled.DivMenuItemWrapper>
      {isShowFANZAlink && (
        <Styled.AnchorFANZA
          href={URL.fanza}
          onClick={() => {
            sendTrackingClickCommon({ clickEventName: "dmmtv_navigation", viaTargetId: "fanzatop" });
          }}
        >
          <Styled.SpanText fontSize={12}>成人向けへ</Styled.SpanText>
          <Styled.SpanText fontSize={10}>FANZA</Styled.SpanText>
        </Styled.AnchorFANZA>
      )}
    </Styled.DivHeader>
  );
};
